import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Toast,
  ToastContainer,
  Modal,
  Alert
} from 'react-bootstrap';

import styles from './ChamadosNovo.module.css';
import { UserContext } from '../../context/UserContext';
import { listaSaudeMental, listaAtencaoBasica } from '../../helpers/listaMedicamentos';
import { listaMateriaisEscritorio } from '../../helpers/listaMateriaisEscritorio';
import { tipoInsumoSelect, tipoMedicamentoSelect } from '../../helpers/suprimentosSelects'
import { listaMateriaisExpediente } from '../../helpers/listaMateriaisExpediente';
import { listaMateriaisLimpeza } from '../../helpers/listaMateriaisLimpeza';
import { cpfMask, matriculaMask, phoneMask } from '../../helpers/masks';
import SuporteTi from '../../components/SuporteTi';
import ManutencaoPredial from '../../components/ManutencaoPredial';
import ManutencaoEquip from '../../components/ManutencaoEquip';
import Reposicao from '../../components/Reposicao';
import Veiculo from '../../components/Veiculo';
import Unidades from '../../components/Unidades';
import Relato from '../../components/Relato';
import Categorias from '../../components/Categorias';
import Email from '../../components/Email';
import MedicamentosSaudeMental from '../../components/MedicamentosSaudeMental';
import MedicamentosAtencaoBasica from '../../components/MedicamentosAtencaoBasica';
import SolicitacaoVeiculo from '../../components/SolicitacaoVeiculo';
import MateriaisEscritorio from '../../components/MateriaisEscritorio';
import MateriaisExpediente from '../../components/MateriaisExpediente';
import MateriaisLimpeza from '../../components/MateriaisLimpeza';
import Suprimentos from '../../components/Suprimentos';
import MedicamentosEmergenciais from '../../components/MedicamentosEmergenciais';
import Eletrica from '../../components/Eletrica';
import Hidrossanitario from '../../components/Hidrossanitario';
import Mecanica from '../../components/Mecanica';
import criarChamado from '../../api/criarChamado';
import editarUsuario from '../../api/editarUsuario';
import getUnidades from '../../api/getUnidades';
import getCategorias from '../../api/getCategorias';
import { decrypt, decryptArray, encrypt } from '../../helpers/cryptography';
import SolicitacaoMotoboy from '../../components/SolicitacaoMotoboy';
import Demonstrativos from '../../components/Demonstrativos';
import ValeRefeicao from '../../components/ValeRefeicao';
import updateValeRefeicao from '../../api/updateValeRefeicao';
import getUserByEmail from '../../api/getUserByEmail';
import Vestuario from '../../components/Vestuario';
import Cadastro from '../../components/Cadastro';
import updateVestuario from '../../api/updateVestuario';
import LoginSistemas from '../../components/LoginSistemas';
import SuporteSistemas from '../../components/SuporteSistemas';
import formatarMatricula from '../../helpers/formatarMatricula';
import Votacao from '../../components/Votacao';
import EngenhariaClinica from '../../components/EngenhariaClinica';
import ManutencaoEquipamentos from '../../components/ManutencaoEquipamentos';
import equipamentosEngenhariaClinica from '../../helpers/equipamentosEngenhariaClinica';
import Ascom from '../../components/Ascom';
import Briefing from '../../components/Briefing';
import getExtension from '../../helpers/getExtension';
import briefingSupportedExtensions from '../../helpers/briefingSupportedExtensions';
import Erp from '../../components/Erp';
import baseUrl from '../../api/baseUrl';
import unidadesPesquisa from '../../helpers/unidadesPesquisa';
import { cnsValidator, cpfValidator, emailValidator } from '../../helpers/validators';
import extensoesSuporte from '../../helpers/extensoesSuporte';
import PontoEletronico from '../../components/PontoEletronico';
import { pontoEletronicoSelect } from '../../helpers/chamadosSelect';
import formatarDataEHora from '../../helpers/formatarDataEHora';
import getCipaInscricao from '../../api/getCipaInscricao';
import CipaInscricao from '../../components/CipaInscricao';
import SuporteTiForm from '../../components/SuporteTiForm';
import ConselhoCuradorInscricao from '../../components/ConselhoCuradorInscricao';
import putConselhoCuradorInscricao from '../../api/conselhoCurador/putConselhoCuradorInscricao';
import Trienio from '../../components/Trienio';
import { insumosService } from '../../api/suprimentos/insumosService';
import { medicamentosService } from '../../api/suprimentos/medicamentosService';

const getLocalDateInputValue = date => {
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

  return offsetDate.toISOString().split('T')[0];
};

const isBeforeToday = dateValue => dateValue < getLocalDateInputValue(new Date());

const getTransportDateTime = (dateValue, timeValue) => {
  if (!dateValue || !timeValue) {
    return null;
  }

  const dateTime = new Date(`${dateValue}T${timeValue}`);

  if (Number.isNaN(dateTime.getTime())) {
    return null;
  }

  return dateTime;
};

const getTransportDateTimeError = (dateValue, timeValue) => {
  if (isBeforeToday(dateValue)) {
    return 'Não é possível agendar um veículo para uma data anterior a data atual.';
  }

  const transportDateTime = getTransportDateTime(dateValue, timeValue);

  if (!transportDateTime) {
    return 'Informe uma data e hora de transporte válidas.';
  }

  const currentDateTime = new Date();

  if (transportDateTime < currentDateTime) {
    return 'Não é possível agendar um veículo para um horário anterior ao horário atual.';
  }

  return '';
};

const ChamadosNovo = () => {
  const { isConsulta, isErp, isInsumosOdonto, isInsumosPmf, isInsumosRaps, isInsumosSrt, isMedicamentos } = useContext(UserContext);
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [categoria, setCategoria] = useState('');
  const [subcategoria, setSubcategoria] = useState('');
  const [unidade, setUnidade] = useState('');
  const [matricula, setMatricula] = useState('');
  const [relato, setRelato] = useState('');
  const [counter, setCounter] = useState(0);
  const [usuario, setUsuario] = useState(null);
  const [userUnidade, setUserUnidade] = useState('');
  const [userNome, setUserNome] = useState('');
  const [userTelefone, setUserTelefone] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userMatricula, setUserMatricula] = useState('');
  const [isRequired, setIsRequired] = useState(true);
  const [mensagemRelato, setMensagemRelato] = useState('*Descreva brevemente a solicitação:');
  const [categorias, setCategorias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [unidades, setUnidades] = useState([]);
  const [valeRefeicao, setValeRefeicao] = useState('');
  const [showModalVRErro, setShowModalVRErro] = useState(false);
  const [showModalVRConfirm, setShowModalVRConfirm] = useState(false);
  const [vrOption, setVrOption] = useState('');
  const [isValeRefeicao, setIsValeRefeicao] = useState(false);
  const [isVestuario, setIsVestuario] = useState(false);
  const [mostrarVestuario, setMostrarVestuario] = useState(true);

  const prazoInscricaoCipaa = true;
  const prazoInscricaoConselhoCurador = false;

  const hasInsumosProfile = isInsumosOdonto || isInsumosPmf || isInsumosRaps || isInsumosSrt;
  const hasEmergencialSuprimentosProfile = hasInsumosProfile || isMedicamentos;

  const medicamentosInitial = {
    medicamento: '',
    quantidade: '1'
  };

  const materiaisInitial = {
    material: '',
    quantidade: '1'
  };

  const suprimentosInitial = {
    tipoInsumo: '',
    codigoInterno: '',
    descricao: '',
    apresentacao: '',
    qtdApresentacao: '',
    quantidade: '1'
  };

  const medicamentosEmergenciaisInitial = {
    tipoMedicamento: '',
    codigoInterno: '',
    descricao: '',
    quantidade: '1'
  };

  const [medicamentosSaudeMental, setMedicamentosSaudeMental] = useState([medicamentosInitial]);
  const [medicamentosAtencaoBasica, setMedicamentosAtencaoBasica] = useState([medicamentosInitial]);
  const [materiaisEscritorio, setMateriaisEscritorio] = useState([materiaisInitial]);
  const [medicamentosEmergenciais, setMedicamentosEmergenciais] = useState([medicamentosEmergenciaisInitial]);
  const [suprimentos, setSuprimentos] = useState([suprimentosInitial]);
  const [materiaisExpediente, setMateriaisExpediente] = useState([materiaisInitial]);
  const [materiaisLimpeza, setMateriaisLimpeza] = useState([materiaisInitial]);
  const [showMedicamentosAtencaoBasica, setShowMedicamentosAtencaoBasica] = useState(false);
  const [materialError, setMaterialError] = useState('');
  const [suprimentoError, setSuprimentoError] = useState('');
  const [listaSuprimentos, setListaSuprimentos] = useState({});
  const [listaInsumosBusca, setListaInsumosBusca] = useState([]);
  const [buscaInsumo, setBuscaInsumo] = useState('');
  const [showInsumoBuscaOptions, setShowInsumoBuscaOptions] = useState(false);
  const [medicamentoEmergencialError, setMedicamentoEmergencialError] = useState('');
  const [listaMedicamentosEmergenciais, setListaMedicamentosEmergenciais] = useState({});
  const [listaMedicamentosBusca, setListaMedicamentosBusca] = useState([]);
  const [buscaMedicamento, setBuscaMedicamento] = useState('');
  const [showMedicamentoBuscaOptions, setShowMedicamentoBuscaOptions] = useState(false);
  const [relatoError, setRelatoError] = useState('');
  const [showRelatoModal, setShowRelatoModal] = useState(false);

  const solicitacaoVeiculoInitialState = {
    veiculoData: '',
    veiculoHora: '',
    veiculoTempo: '',
    veiculoPassageiro: '',
    veiculoTelefone: '',
    veiculoMotivo: '',
    veiculoSaida: '',
    veiculoDestino: ''
  };

  const solicitacaoMotoboyInitialState = {
    motoboyData: '',
    motoboyHora: '',
    motoboyTempo: '',
    motoboyPassageiro: '',
    motoboyTelefone: '',
    motoboyMotivo: '',
    motoboySaida: '',
    motoboyDestino: ''
  };

  const createEmailInitialState = {
    registration: '',
    name: '',
    email: '',
    phone: '',
    admissionDate: '',
    unit: '',
    job: '',
    sisged: true
  };

  const loginSuporteInitialState = {
    tipo: '',
    unidade: '',
    nome: '',
    cpf: '',
    cns: '',
    equipe: '',
    cbo: '',
    registroProfissional: '',
    email: '',
    telefone: ''
  };

  const [solicitacaoVeiculo, setSolicitacaoVeiculo] = useState(solicitacaoVeiculoInitialState);
  const [solicitacaoMotoboy, setSolicitacaoMotoboy] = useState(solicitacaoMotoboyInitialState);
  const [createEmail, setCreateEmail] = useState(createEmailInitialState);

  const [veiculoError, setVeiculoError] = useState('');

  const [numeroCalcado, setNumeroCalcado] = useState('');
  const [calcado, setCalcado] = useState('');
  const [vestuarioError, setVestuarioError] = useState('');
  const [showVestuarioModal, setShowVestuarioModal] = useState(false);
  const [camisa, setCamisa] = useState('');
  const [calca, setCalca] = useState('');
  const [jaleco, setJaleco] = useState('');
  const [vestuarioObservacoes, setVestuarioObservacoes] = useState('');
  const [showVestuarioToast, setShowVestuarioToast] = useState(false);
  const [showModalVestuarioConfirm, setShowModalVestuarioConfirm] = useState(false);
  const [showVestuarioMessageModal, setShowVestuarioMessageModal] = useState(true);

  const [loginSistemas, setLoginSistemas] = useState('');
  const [loginSuporte, setLoginSuporte] = useState(loginSuporteInitialState);
  const [showLoginSistemasModal, setShowLoginSistemasModal] = useState(false);
  const [loginSistemasError, setLoginSistemasError] = useState('');

  const [showModal, setShowModal] = useState(false);

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailError, setEmailError] = useState('');

  const [cipaInscricao, setCipaInscricao] = useState({});

  const [equipamentoEngenhariaClinica, setEquipamentoEngenhariaClinica] = useState('');
  const [equipamentoEngenhariaClinicaError, setEquipamentoEngenhariaClinicaError] = useState('');
  const [showEquipamentoEngenhariaClinicaModal, setShowEquipamentoEngenhariaClinicaModal] = useState(false);

  const [briefingPorque, setBriefingPorque] = useState('');
  const [briefingMedidas, setBriefingMedidas] = useState('');
  const [briefingOnde, setBriefingOnde] = useState('');
  const [briefingArquivo1, setBriefingArquivo1] = useState(null);
  const [briefingArquivo2, setBriefingArquivo2] = useState(null);
  const [briefingArquivo3, setBriefingArquivo3] = useState(null);
  const [briefingArquivo4, setBriefingArquivo4] = useState(null);
  const [briefingArquivo5, setBriefingArquivo5] = useState(null);
  const [briefingPrazo, setBriefingPrazo] = useState('');
  const [briefingDetalhe, setBriefingDetalhe] = useState('');
  const [showBriefingModal, setShowBriefingModal] = useState(false);
  const [briefingError, setBriefingError] = useState('');

  const [trienioArquivo1, setTrienioArquivo1] = useState(null);
  const [trienioArquivo2, setTrienioArquivo2] = useState(null);
  const [trienioArquivo3, setTrienioArquivo3] = useState(null);
  const [trienioArquivo4, setTrienioArquivo4] = useState(null);
  const [trienioArquivo5, setTrienioArquivo5] = useState(null);
  const [showTrienioModal, setShowTrienioModal] = useState(false);
  const [trienioError, setTrienioError] = useState('');

  const [suporteArquivo1, setSuporteArquivo1] = useState(null);
  const [suporteArquivo2, setSuporteArquivo2] = useState(null);
  const [suporteArquivo3, setSuporteArquivo3] = useState(null);
  const [suporteArquivo4, setSuporteArquivo4] = useState(null);
  const [suporteArquivo5, setSuporteArquivo5] = useState(null);
  const [showSuporteModal, setShowSuporteModal] = useState(false);
  const [suporteError, setSuporteError] = useState('');

  const [erpNome, setErpNome] = useState('');
  const [erpEmail, setErpEmail] = useState('');
  const [erpMatricula, setErpMatricula] = useState('');
  const [erpUnidade, setErpUnidade] = useState('');
  const [erpAdministrador, setErpAdministrador] = useState('0 - Sem acesso');
  const [erpCadastrosComuns, setErpCadastrosComuns] = useState('0 - Sem acesso');
  const [erpCadastrosComumFinanceiro, setErpCadastrosComumFinanceiro] = useState('0 - Sem acesso');
  const [erpGestaoDeProcessos, setErpGestaoDeProcessos] = useState('0 - Sem acesso');
  const [erpCompras, setErpCompras] = useState('0 - Sem acesso');
  const [erpContratoCompras, setErpContratoCompras] = useState('0 - Sem acesso');
  const [erpContasPagar, setErpContasPagar] = useState('0 - Sem acesso');
  const [erpPagamentoEscritural, setErpPagamentoEscritural] = useState('0 - Sem acesso');
  const [erpContasReceber, setErpContasReceber] = useState('0 - Sem acesso');
  const [erpTesouraria, setErpTesouraria] = useState('0 - Sem acesso');
  const [erpIntegracaoPadrao, setErpIntegracaoPadrao] = useState('0 - Sem acesso');
  const [erpContabil, setErpContabil] = useState('0 - Sem acesso');
  const [erpEstoque, setErpEstoque] = useState('0 - Sem acesso');
  const [erpPatrimonio, setErpPatrimonio] = useState('0 - Sem acesso');
  const [erpOrcamento, setErpOrcamento] = useState('0 - Sem acesso');
  const [erpReinf, setErpReinf] = useState('0 - Sem acesso');
  const [erpEfd, setErpEfd] = useState('0 - Sem acesso');
  const [erpEcd, setErpEcd] = useState('0 - Sem acesso');
  const [erpEcf, setErpEcf] = useState('0 - Sem acesso');
  const [showErpModal, setShowErpModal] = useState(false);
  const [erpError, setErpError] = useState('');

  const [telContatoTi, setTelContatoTi] = useState('');
  const [patrimonioTi, setPatrimonioTi] = useState('');
  const [showTiModal, setShowTiModal] = useState(false);
  const [tiError, setTiError] = useState('');

  const handleTiModalClose = () => setShowTiModal(false);

  const handleTelContatoTi = e => {
    setTelContatoTi(phoneMask(e.target.value));
  };

  const handlePatrimonioTi = e => setPatrimonioTi(e.target.value);

  const [pontoEletronico, setPontoEletronico] = useState('');
  const handlePontoEletronico = e => setPontoEletronico(e.target.value);

  const handleErpNome = e => setErpNome(e.target.value);
  const handleErpEmail = e => setErpEmail(e.target.value);
  const handleErpMatricula = e => {
    e.target.value = matriculaMask(e.target.value);

    setErpMatricula(e.target.value);
  };
  const handleErpUnidade = e => setErpUnidade(e.target.value);
  const handleErpAdministrador = e => setErpAdministrador(e.target.value);
  const handleErpCadastrosComuns = e => setErpCadastrosComuns(e.target.value);
  const handleErpCadastrosComumFinanceiro = e => setErpCadastrosComumFinanceiro(e.target.value);
  const handleErpGestaoDeProcessos = e => setErpGestaoDeProcessos(e.target.value);
  const handleErpCompras = e => setErpCompras(e.target.value);
  const handleErpContratoCompras = e => setErpContratoCompras(e.target.value);
  const handleErpContasPagar = e => setErpContasPagar(e.target.value);
  const handleErpPagamentoEscritural = e => setErpPagamentoEscritural(e.target.value);
  const handleErpContasReceber = e => setErpContasReceber(e.target.value);
  const handleErpTesouraria = e => setErpTesouraria(e.target.value);
  const handleErpIntegracaoPadrao = e => setErpIntegracaoPadrao(e.target.value);
  const handleErpContabil = e => setErpContabil(e.target.value);
  const handleErpEstoque = e => setErpEstoque(e.target.value);
  const handleErpPatrimonio = e => setErpPatrimonio(e.target.value);
  const handleErpOrcamento = e => setErpOrcamento(e.target.value);
  const handleErpReinf = e => setErpReinf(e.target.value);
  const handleErpEfd = e => setErpEfd(e.target.value);
  const handleErpEcd = e => setErpEcd(e.target.value);
  const handleErpEcf = e => setErpEcf(e.target.value);
  const handleErpModalClose = () => setShowErpModal(false);

  const handleBriefingPorque = e => setBriefingPorque(e.target.value);
  const handleBriefingMedidas = e => setBriefingMedidas(e.target.value);
  const handleBriefingOnde = e => setBriefingOnde(e.target.value);
  const handleBriefingPrazo = e => setBriefingPrazo(e.target.value);
  const handleBriefingDetalhe = e => setBriefingDetalhe(e.target.value);
  const handleBriefingModalClose = () => setShowBriefingModal(false);

  const handleTrienioModalClose = () => setShowTrienioModal(false);

  const handleSuporteModalClose = () => setShowSuporteModal(false);

  const handleBriefingArquivo = (e, ref) => {
    const nomeArquivo = ref.current.name;
    const extension = getExtension(e.target.files[0].name);

    if (!briefingSupportedExtensions.includes(extension)) {
      setBriefingError('Tipo de arquivo não suportado');
      setShowBriefingModal(true);

      e.target.value = null;

      if (nomeArquivo === 'briefingArquivo1') {
        setBriefingArquivo1(null);
      } else if (nomeArquivo === 'briefingArquivo2') {
        setBriefingArquivo2(null);
      } else if (nomeArquivo === 'briefingArquivo3') {
        setBriefingArquivo3(null);
      } else if (nomeArquivo === 'briefingArquivo4') {
        setBriefingArquivo4(null);
      } else if (nomeArquivo === 'briefingArquivo5') {
        setBriefingArquivo5(null);
      }

      return null;
    }

    if (e.target.files[0].size > 5242880) {
      setBriefingError('Arquivo excede o limite de 5MB');
      setShowBriefingModal(true);

      e.target.value = null;

      if (nomeArquivo === 'briefingArquivo1') {
        setBriefingArquivo1(null);
      } else if (nomeArquivo === 'briefingArquivo2') {
        setBriefingArquivo2(null);
      } else if (nomeArquivo === 'briefingArquivo3') {
        setBriefingArquivo3(null);
      } else if (nomeArquivo === 'briefingArquivo4') {
        setBriefingArquivo4(null);
      } else if (nomeArquivo === 'briefingArquivo5') {
        setBriefingArquivo5(null);
      }

      return null;
    }

    if (nomeArquivo === 'briefingArquivo1') {
      setBriefingArquivo1(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo2') {
      setBriefingArquivo2(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo3') {
      setBriefingArquivo3(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo4') {
      setBriefingArquivo4(e.target.files[0]);
    } else if (nomeArquivo === 'briefingArquivo5') {
      setBriefingArquivo5(e.target.files[0]);
    }
  };
  const handleTrienioArquivo = (e, ref) => {
    const nomeArquivo = ref.current.name;
    const extension = getExtension(e.target.files[0].name);

    if (extension !== 'pdf') {
      setTrienioError('Só é permitido anexar arquivos PDF');
      setShowTrienioModal(true);

      e.target.value = null;

      if (nomeArquivo === 'trienioArquivo1') {
        setTrienioArquivo1(null);
      } else if (nomeArquivo === 'trienioArquivo2') {
        setTrienioArquivo2(null);
      } else if (nomeArquivo === 'trienioArquivo3') {
        setTrienioArquivo3(null);
      } else if (nomeArquivo === 'trienioArquivo4') {
        setTrienioArquivo4(null);
      } else if (nomeArquivo === 'trienioArquivo5') {
        setTrienioArquivo5(null);
      }

      return null;
    }

    if (e.target.files[0].size > 5242880) {
      setTrienioError('Arquivo excede o limite de 5MB');
      setShowTrienioModal(true);

      e.target.value = null;

      if (nomeArquivo === 'trienioArquivo1') {
        setTrienioArquivo1(null);
      } else if (nomeArquivo === 'trienioArquivo2') {
        setTrienioArquivo2(null);
      } else if (nomeArquivo === 'trienioArquivo3') {
        setTrienioArquivo3(null);
      } else if (nomeArquivo === 'trienioArquivo4') {
        setTrienioArquivo4(null);
      } else if (nomeArquivo === 'trienioArquivo5') {
        setTrienioArquivo5(null);
      }

      return null;
    }

    if (nomeArquivo === 'trienioArquivo1') {
      setTrienioArquivo1(e.target.files[0]);
    } else if (nomeArquivo === 'trienioArquivo2') {
      setTrienioArquivo2(e.target.files[0]);
    } else if (nomeArquivo === 'trienioArquivo3') {
      setTrienioArquivo3(e.target.files[0]);
    } else if (nomeArquivo === 'trienioArquivo4') {
      setTrienioArquivo4(e.target.files[0]);
    } else if (nomeArquivo === 'trienioArquivo5') {
      setTrienioArquivo5(e.target.files[0]);
    }
  };

  const resetBriefingArquivo = ref => {
    ref.current.value = null;

    const name = ref.current.name;

    if (name === 'briefingArquivo1') {
      setBriefingArquivo1(null);
    } else if (name === 'briefingArquivo2') {
      setBriefingArquivo2(null);
    } else if (name === 'briefingArquivo3') {
      setBriefingArquivo3(null);
    } else if (name === 'briefingArquivo4') {
      setBriefingArquivo4(null);
    } else if (name === 'briefingArquivo5') {
      setBriefingArquivo5(null);
    }
  };

  const resetTrienioArquivo = ref => {
    ref.current.value = null;

    const name = ref.current.name;

    if (name === 'trienioArquivo1') {
      setTrienioArquivo1(null);
    } else if (name === 'trienioArquivo2') {
      setTrienioArquivo2(null);
    } else if (name === 'trienioArquivo3') {
      setTrienioArquivo3(null);
    } else if (name === 'trienioArquivo4') {
      setTrienioArquivo4(null);
    } else if (name === 'trienioArquivo5') {
      setTrienioArquivo5(null);
    }
  };

  const handleSuporteArquivo = (e, ref) => {
    const nomeArquivo = ref.current.name;
    const extension = getExtension(e.target.files[0].name);

    if (!extensoesSuporte.includes(extension)) {
      setSuporteError('Tipo de arquivo não suportado');
      setShowSuporteModal(true);

      e.target.value = null;

      if (nomeArquivo === 'suporteArquivo1') {
        setSuporteArquivo1(null);
      } else if (nomeArquivo === 'suporteArquivo2') {
        setSuporteArquivo2(null);
      } else if (nomeArquivo === 'suporteArquivo3') {
        setSuporteArquivo3(null);
      } else if (nomeArquivo === 'suporteArquivo4') {
        setSuporteArquivo4(null);
      } else if (nomeArquivo === 'suporteArquivo5') {
        setSuporteArquivo5(null);
      }

      return null;
    }

    if (e.target.files[0].size > 5242880) {
      setSuporteError('Arquivo excede o limite de 5MB');
      setShowSuporteModal(true);

      e.target.value = null;

      if (nomeArquivo === 'suporteArquivo1') {
        setSuporteArquivo1(null);
      } else if (nomeArquivo === 'suporteArquivo2') {
        setSuporteArquivo2(null);
      } else if (nomeArquivo === 'suporteArquivo3') {
        setSuporteArquivo3(null);
      } else if (nomeArquivo === 'suporteArquivo4') {
        setSuporteArquivo4(null);
      } else if (nomeArquivo === 'suporteArquivo5') {
        setSuporteArquivo5(null);
      }

      return null;
    }

    if (nomeArquivo === 'suporteArquivo1') {
      setSuporteArquivo1(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo2') {
      setSuporteArquivo2(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo3') {
      setSuporteArquivo3(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo4') {
      setSuporteArquivo4(e.target.files[0]);
    } else if (nomeArquivo === 'suporteArquivo5') {
      setSuporteArquivo5(e.target.files[0]);
    }
  };

  const resetSuporteArquivo = ref => {
    ref.current.value = null;

    const name = ref.current.name;

    if (name === 'suporteArquivo1') {
      setSuporteArquivo1(null);
    } else if (name === 'suporteArquivo2') {
      setSuporteArquivo2(null);
    } else if (name === 'suporteArquivo3') {
      setSuporteArquivo3(null);
    } else if (name === 'suporteArquivo4') {
      setSuporteArquivo4(null);
    } else if (name === 'suporteArquivo5') {
      setSuporteArquivo5(null);
    }
  };

  const handleEquipamentoEngenhariaClinicaModalClose = () => setShowEquipamentoEngenhariaClinicaModal(false);

  const [cipaInscricaoUnidade, setCipaInscricaoUnidade] = useState('');
  const [cipaInscricaoCargo, setCipaInscricaoCargo] = useState('');
  const [cipaInscricaoSobre, setCipaInscricaoSobre] = useState('');
  const [showCipaInscricaoModal, setShowCipaInscricaoModal] = useState(false);
  const [cipaInscricaoError, setCipaInscricaoError] = useState('');

  const [conselhoCuradorInscricao, setConselhoCuradorInscricao] = useState({});
  const [conselhoCuradorInscricaoUnidade, setConselhoCuradorInscricaoUnidade] = useState('');
  const [conselhoCuradorInscricaoCargo, setConselhoCuradorInscricaoCargo] = useState('');
  const [conselhoCuradorInscricaoSobre, setConselhoCuradorInscricaoSobre] = useState('');
  const [showConselhoCuradorInscricaoModal, setShowConselhoCuradorInscricaoModal] = useState(false);
  const [conselhoCuradorInscricaoError, setConselhoCuradorInscricaoError] = useState('');

  const handleConselhoCuradorInscricaoUnidade = e => setConselhoCuradorInscricaoUnidade(e.target.value);
  const handleConselhoCuradorInscricaoCargo = e => setConselhoCuradorInscricaoCargo(e.target.value);
  const handleConselhoCuradorInscricaoSobre = e => setConselhoCuradorInscricaoSobre(e.target.checked);
  const handleConselhoCuradorInscricaoModalClose = () => setShowConselhoCuradorInscricaoModal(false);

  const handleCipaInscricaoUnidade = e => setCipaInscricaoUnidade(e.target.value);
  const handleCipaInscricaoCargo = e => setCipaInscricaoCargo(e.target.value);
  const handleCipaInscricaoSobre = e => setCipaInscricaoSobre(e.target.checked);

  const handleCipaInscricaoModalClose = () => setShowCipaInscricaoModal(false);

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleRelatoModalClose = () => setShowRelatoModal(false);
  const handleVestuarioModalClose = () => setShowVestuarioModal(false);
  const handleModalVestuarioConfirmClose = () => setShowModalVestuarioConfirm(false);
  const handleVestuarioMessageModalClose = () => setShowVestuarioMessageModal(false);
  const handleLoginSistemasModalClose = () => setShowLoginSistemasModal(false);

  const closeEmailModal = () => setShowEmailModal(false);

  const handleCreateEmail = e => {
    let { name, value } = e.target;

    if (name === 'phone') {
      e.target.value = phoneMask(e.target.value);
    }

    if (name === 'registration') {
      e.target.value = matriculaMask(e.target.value);
    }

    const list = { ...createEmail, [name]: value };

    setCreateEmail(list);
  };

  const handleAddMedicamentoSaudeMental = () => {
    setMedicamentosSaudeMental([...medicamentosSaudeMental, medicamentosInitial]);
  };

  const handleAddMedicamentoAtencaoBasica = () => {
    setMedicamentosAtencaoBasica([...medicamentosAtencaoBasica, medicamentosInitial]);
  };

  const handleAddMateriaisEscritorio = () => {
    setMateriaisEscritorio([...materiaisEscritorio, materiaisInitial]);
  };

  const handleAddSuprimentos = () => {
    setSuprimentos([...suprimentos, suprimentosInitial]);
    setBuscaInsumo('');
  };

  const handleAddMateriaisExpediente = () => {
    setMateriaisExpediente([...materiaisExpediente, materiaisInitial]);
  };

  const handleAddMateriaisLimpeza = () => {
    setMateriaisLimpeza([...materiaisLimpeza, materiaisInitial]);
  };

  const handleRemoveMedicamentoSaudeMental = index => {
    handleModalClose();

    let list = [...medicamentosSaudeMental];
    list.splice(index, 1);

    setMedicamentosSaudeMental(list);
  };

  const handleRemoveMedicamentoAtencaoBasica = index => {
    let list = [...medicamentosAtencaoBasica];
    list.splice(index, 1);

    setMedicamentosAtencaoBasica(list);
  };

  const handleRemoveMateriaisEscritorio = index => {
    let list = [...materiaisEscritorio];
    list.splice(index, 1);

    setMateriaisEscritorio(list);
  };

  const handleRemoveSuprimentos = index => {
    let list = [...suprimentos];
    list.splice(index, 1);

    setSuprimentos(list);
  };

  const handleRemoveMateriaisExpediente = index => {
    let list = [...materiaisExpediente];
    list.splice(index, 1);

    setMateriaisExpediente(list);
  };

  const handleRemoveMateriaisLimpeza = index => {
    let list = [...materiaisLimpeza];
    list.splice(index, 1);

    setMateriaisLimpeza(list);
  };

  const handleMedicamentosSaudeMental = (position, field, item) => {
    const updatedMedicamentos = medicamentosSaudeMental.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMedicamentosSaudeMental(updatedMedicamentos);
  };

  const handleMedicamentosAtencaoBasica = (position, field, item) => {
    const updatedMedicamentos = medicamentosAtencaoBasica.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMedicamentosAtencaoBasica(updatedMedicamentos);
  };

  const handleMateriaisEscritorio = (position, field, item) => {
    const updatedMateriaisEscritorio = materiaisEscritorio.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMateriaisEscritorio(updatedMateriaisEscritorio);
  };

  const handleSuprimentos = (position, field, item) => {
    const updatedSuprimento = suprimentos.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setSuprimentos(updatedSuprimento);
  };

  const handleSuprimentoSelecionado = (position, insumo) => {
    const updatedSuprimento = suprimentos.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, ...insumo };
      }

      return standardItem;
    });

    setSuprimentos(updatedSuprimento);
  };

  function formatInsumoDescricao(insumo) {
    return [
      insumo?.descricao,
      insumo?.apresentacao,
      insumo?.qtdApresentacao
    ].filter(Boolean).join(' / ');
  }

  function getBuscaInsumoTargetIndex() {
    const emptyIndex = suprimentos.findIndex(item => !item.descricao && !item.codigoInterno);

    if (emptyIndex !== -1) {
      return emptyIndex;
    }

    return Math.max(suprimentos.length - 1, 0);
  }

  function handleBuscaInsumo(value) {
    setBuscaInsumo(value);
    setShowInsumoBuscaOptions(Boolean(value));

    const insumo = listaInsumosBusca.find(item => formatInsumoDescricao(item) === value);

    if (!insumo) {
      return;
    }

    setShowInsumoBuscaOptions(false);
    handleSuprimentoSelecionado(getBuscaInsumoTargetIndex(), {
      tipoInsumo: insumo.tipoInsumo,
      codigoInterno: insumo.codigoInterno !== undefined && insumo.codigoInterno !== null ? String(insumo.codigoInterno) : '',
      descricao: insumo.descricao,
      apresentacao: insumo.apresentacao,
      qtdApresentacao: insumo.qtdApresentacao
    });
  }

  function handleSelecionarInsumoBusca(insumo) {
    setBuscaInsumo(formatInsumoDescricao(insumo));
    setShowInsumoBuscaOptions(false);
    handleSuprimentoSelecionado(getBuscaInsumoTargetIndex(), {
      tipoInsumo: insumo.tipoInsumo,
      codigoInterno: insumo.codigoInterno !== undefined && insumo.codigoInterno !== null ? String(insumo.codigoInterno) : '',
      descricao: insumo.descricao,
      apresentacao: insumo.apresentacao,
      qtdApresentacao: insumo.qtdApresentacao
    });
  }

  function filtrarInsumosPorPerfil(insumos) {
    const perfisInsumos = {
      isInsumosOdonto: 'ODONTO',
      isInsumosPmf: 'PMF',
      isInsumosRaps: 'RAPS',
      isInsumosSrt: 'SRT',
    };

    const perfisUsuarioBooleans = {
      isInsumosOdonto,
      isInsumosPmf,
      isInsumosRaps,
      isInsumosSrt,
    };

    const perfisAtivos = Object.entries(perfisUsuarioBooleans)
      .filter(([_, ativo]) => ativo)
      .map(([chave]) => perfisInsumos[chave]);

    if (!perfisAtivos.length) {
      return [];
    }

    return insumos.filter(
      (insumo) =>
        insumo.status !== 'INATIVO' &&
        insumo.segmento?.some((seg) => perfisAtivos.includes(seg))
    );
  }

  function agruparInsumosPorTipo(insumos) {
    return insumos.reduce((acc, insumo) => ({
      ...acc,
      [insumo.tipoInsumo]: [
        ...(acc[insumo.tipoInsumo] ?? []),
        insumo
      ]
    }), {});
  }

  const handleTipoInsumo = async (index, tipoInsumo) => {
    const updatedSuprimento = suprimentos.map((standardItem, i) => {
      if (i === index) {
        return {
          ...standardItem,
          tipoInsumo: tipoInsumo,
          codigoInterno: '',
          descricao: '',
          apresentacao: '',
          qtdApresentacao: ''
        };
      }
      return standardItem;
    });

    setSuprimentos(updatedSuprimento);

    const getInsumos = await insumosService.allInsumos('tipoInsumo', tipoInsumo, 1, 1_000_000, 'descricao', 'asc');

    const insumos = getInsumos.insumos;

    const listaInsumosPorPerfil = filtrarInsumosPorPerfil(insumos);

    setListaSuprimentos(prev => ({
      ...prev,
      [tipoInsumo]: listaInsumosPorPerfil
    }));
  };

  const getListaSuprimentosByTipo = (tipoInsumo) => {
    return listaSuprimentos[tipoInsumo] || [];
  };

  const handleAddMedicamentosEmergenciais = () => {
    setMedicamentosEmergenciais([...medicamentosEmergenciais, medicamentosEmergenciaisInitial]);
    setBuscaMedicamento('');
  };

  const handleRemoveMedicamentosEmergenciais = index => {
    let list = [...medicamentosEmergenciais];
    list.splice(index, 1);

    setMedicamentosEmergenciais(list);
  };

  const handleMedicamentosEmergenciais = (position, field, item) => {
    const updatedMedicamento = medicamentosEmergenciais.map((standardItem, index) => {
      if (index === position) {
        if (field === 'descricao') {
          const medicamentoSelecionado = getListaMedicamentosByTipo(standardItem.tipoMedicamento)
            .find(medicamento => medicamento.descricao === item);

          return {
            ...standardItem,
            descricao: item,
            codigoInterno: medicamentoSelecionado?.codigoInterno !== undefined && medicamentoSelecionado?.codigoInterno !== null
              ? String(medicamentoSelecionado.codigoInterno)
              : ''
          };
        }

        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMedicamentosEmergenciais(updatedMedicamento);
  };

  const handleMedicamentoEmergencialSelecionado = (position, medicamento) => {
    const updatedMedicamento = medicamentosEmergenciais.map((standardItem, index) => {
      if (index === position) {
        return {
          ...standardItem,
          tipoMedicamento: medicamento.tipoMedicamento,
          codigoInterno: medicamento.codigoInterno !== undefined && medicamento.codigoInterno !== null ? String(medicamento.codigoInterno) : '',
          descricao: medicamento.descricao
        };
      }

      return standardItem;
    });

    setMedicamentosEmergenciais(updatedMedicamento);
  };

  function getBuscaMedicamentoTargetIndex() {
    const emptyIndex = medicamentosEmergenciais.findIndex(item => !item.descricao);

    if (emptyIndex !== -1) {
      return emptyIndex;
    }

    return Math.max(medicamentosEmergenciais.length - 1, 0);
  }

  function handleBuscaMedicamento(value) {
    setBuscaMedicamento(value);
    setShowMedicamentoBuscaOptions(Boolean(value));

    const medicamento = listaMedicamentosBusca.find(item => item.descricao === value);

    if (!medicamento) {
      return;
    }

    setShowMedicamentoBuscaOptions(false);
    handleMedicamentoEmergencialSelecionado(getBuscaMedicamentoTargetIndex(), medicamento);
  }

  function handleSelecionarMedicamentoBusca(medicamento) {
    setBuscaMedicamento(medicamento.descricao);
    setShowMedicamentoBuscaOptions(false);
    handleMedicamentoEmergencialSelecionado(getBuscaMedicamentoTargetIndex(), medicamento);
  }

  function agruparMedicamentosPorTipo(medicamentos) {
    return medicamentos.reduce((acc, medicamento) => ({
      ...acc,
      [medicamento.tipoMedicamento]: [
        ...(acc[medicamento.tipoMedicamento] ?? []),
        medicamento
      ]
    }), {});
  }

  const handleTipoMedicamento = async (index, tipoMedicamento) => {
    const updatedMedicamento = medicamentosEmergenciais.map((standardItem, i) => {
      if (i === index) {
        return {
          ...standardItem,
          tipoMedicamento: tipoMedicamento,
          codigoInterno: '',
          descricao: ''
        };
      }

      return standardItem;
    });

    setMedicamentosEmergenciais(updatedMedicamento);

    const getMedicamentos = await medicamentosService.allMedicamentos(
      'tipoMedicamento',
      tipoMedicamento,
      1,
      1_000_000,
      'descricao',
      'asc',
    );

    const medicamentos = getMedicamentos.medicamentos;

    setListaMedicamentosEmergenciais(prev => ({
      ...prev,
      [tipoMedicamento]: medicamentos,
    }));
  };

  const getListaMedicamentosByTipo = (tipoMedicamento) => {
    return listaMedicamentosEmergenciais[tipoMedicamento] || [];
  };

  const handleMateriaisExpediente = (position, field, item) => {
    const updatedMateriaisExpediente = materiaisExpediente.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMateriaisExpediente(updatedMateriaisExpediente);
  };

  const handleMateriaisLimpeza = (position, field, item) => {
    const updatedMateriaisLimpeza = materiaisLimpeza.map((standardItem, index) => {
      if (index === position) {
        return { ...standardItem, [field]: item };
      }

      return standardItem;
    });

    setMateriaisLimpeza(updatedMateriaisLimpeza);
  };

  const handleSwitch = () => {
    setShowMedicamentosAtencaoBasica(!showMedicamentosAtencaoBasica);

    setMedicamentosAtencaoBasica([medicamentosInitial]);
  };

  const handleLoginSistemas = e => {
    setLoginSistemas(e.target.value);
  };

  const handleLoginSuporte = e => {
    let { name, value } = e.target;

    if (name === 'telefone') {
      e.target.value = phoneMask(e.target.value);
    }

    if (name === 'cpf') {
      e.target.value = cpfMask(e.target.value);
    }

    if (name === 'cbo') {
      value = value.replace(/\D/g, '').slice(0, 6);
      e.target.value = value;
    }

    if (name === 'tipo') {
      setLoginSistemas('');
    }

    const list = { ...loginSuporte, [name]: value };

    setLoginSuporte(list);
  };

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('login'));

    let exercicioDe;

    if (data?.user?.admissionDate) {
      const day = new Date(data?.user?.admissionDate).getUTCDate();
      const month = new Date(data?.user?.admissionDate).getUTCMonth();
      const actualYear = new Date().getUTCFullYear() - 1;
      exercicioDe = new Date(actualYear, month, day);
    }

    const exercicioA = new Date(exercicioDe);
    exercicioA.setDate(exercicioA.getDate() + 365);
    const userUnit = decrypt(data?.user?.unit);

    setUsuario(decrypt(data?.user?.name));
    setUserUnidade(userUnit);
    setUserNome(decrypt(data?.user?.name));

    if (data?.user?.phone) {
      setUserTelefone(decrypt(data?.user?.phone));
      setTelefone(decrypt(data?.user?.phone));
    }

    if (data?.user?.registration) {
      setUserMatricula(decrypt(data?.user?.registration));
      setMatricula(decrypt(data?.user?.registration));
    }

    setUserEmail(decrypt(data?.user?.email));
    setEmail(decrypt(data?.user?.email));
    setNome(decrypt(data?.user?.name));
    setUnidade(userUnit);
  }, []);

  useEffect(() => {
    const units = async () => {
      const response = await getUnidades('sisged');

      setUnidades(response ?? []);
    };

    units();
  }, []);

  useEffect(() => {
    if (!unidades.length || !userUnidade) {
      return;
    }

    const unidadeExists = unidades.some(item => item.unidade === userUnidade);

    if (!unidadeExists) {
      setUnidade('');
      setUserUnidade('');
    }
  }, [unidades, userUnidade]);

  useEffect(() => {
    const categories = async () => {
      let response = await getCategorias();
      response = response
        .filter(categoria => (
          categoria.categoria !== 'Requisição Emergencial de Suprimentos' ||
          hasEmergencialSuprimentosProfile
        ))
        .map(categoria => {
          if (categoria.categoria !== 'Requisição Emergencial de Suprimentos') {
            return categoria;
          }

          return {
            ...categoria,
            subcategoria: categoria.subcategoria.filter(item => (
              (item.nome !== 'Solicitação emergencial de insumos' || hasInsumosProfile) &&
              (item.nome !== 'Solicitação emergencial de medicamentos' || isMedicamentos)
            ))
          };
        });

      if (isConsulta) {
        const categoriasConsulta = response.filter(categoria => categoria.id === 1 || categoria.id === 10 || categoria.id === 11 || categoria.id === 12 || categoria.id === 15);

        setCategorias(categoriasConsulta);

        return;
      }

      if (!unidade.includes('Diretoria')) {
        let filterCategorias = response.filter(categoria => categoria.id !== 9);

        if (!hasEmergencialSuprimentosProfile) {
          filterCategorias = response.filter(categoria => categoria.id !== 7);
        }

        setCategorias(filterCategorias);
      } else {
        setCategorias(response);
      }

      return response;
    };

    categories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unidade, hasEmergencialSuprimentosProfile, hasInsumosProfile, isMedicamentos]);

  const handleEmail = e => {
    setEmail(e.target.value);
  };

  const handleNome = e => {
    setNome(e.target.value);
    setUserNome(e.target.value);
  };

  const handleTelefone = e => {
    const telMask = phoneMask(e.target.value);

    setTelefone(telMask);
    setUserTelefone(telMask);
  };

  const handleCategoria = e => {
    setCategoria(e.target.value);
    setSubcategoria('');
    setBuscaInsumo('');
    setShowInsumoBuscaOptions(false);
    setBuscaMedicamento('');
    setShowMedicamentoBuscaOptions(false);
  };

  useEffect(() => {
    if (categoria === 'Reposição de Material/Estoque' || subcategoria === 'Criação de e-mail corporativo') {
      setIsRequired(false);
      setMensagemRelato('Observações:');
    } else if (categoria === 'Requisição Emergencial de Suprimentos') {
      setIsRequired(true);
      setMensagemRelato('*Observação/Justificativa:');
    } else {
      setIsRequired(true);
      setMensagemRelato('*Descreva brevemente a solicitação:');
    }
  }, [categoria, subcategoria]);

  const handleSubcategoria = e => {
    setSubcategoria(e.target.value);
    setBuscaInsumo('');
    setShowInsumoBuscaOptions(false);
    setBuscaMedicamento('');
    setShowMedicamentoBuscaOptions(false);
  };

  useEffect(() => {
    const carregarInsumosBusca = async () => {
      if (subcategoria !== 'Solicitação emergencial de insumos') {
        setListaInsumosBusca([]);
        return;
      }

      const getInsumos = await insumosService.allInsumos('', '', 1, 1_000_000, 'descricao', 'asc');
      const insumos = filtrarInsumosPorPerfil(getInsumos.insumos ?? []);

      setListaInsumosBusca(insumos);
      setListaSuprimentos(prev => ({
        ...prev,
        ...agruparInsumosPorTipo(insumos)
      }));
    };

    carregarInsumosBusca();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategoria, isInsumosOdonto, isInsumosPmf, isInsumosRaps, isInsumosSrt]);

  useEffect(() => {
    const carregarMedicamentosBusca = async () => {
      if (subcategoria !== 'Solicitação emergencial de medicamentos') {
        setListaMedicamentosBusca([]);
        return;
      }

      const getMedicamentos = await medicamentosService.allMedicamentos('', '', 1, 1_000_000, 'descricao', 'asc');
      const medicamentos = getMedicamentos?.medicamentos ?? [];

      setListaMedicamentosBusca(medicamentos);
      setListaMedicamentosEmergenciais(prev => ({
        ...prev,
        ...agruparMedicamentosPorTipo(medicamentos)
      }));
    };

    carregarMedicamentosBusca();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategoria]);

  const handleUnidade = e => {
    setUnidade(e.target.value);
    setUserUnidade(e.target.value);
  };

  const handleRelato = e => {
    let currentLength = e.target.value.length;

    setCounter(currentLength);
    setRelato(e.target.value);
  };

  const handleSolicitacaoVeiculo = e => {
    let { name, value } = e.target;

    if (name === 'veiculoTelefone') {
      e.target.value = phoneMask(e.target.value);
    }

    const list = { ...solicitacaoVeiculo, [name]: value };

    setSolicitacaoVeiculo(list);
  };

  const handleSolicitacaoMotoboy = e => {
    let { name, value } = e.target;

    if (name === 'motoboyTelefone') {
      e.target.value = phoneMask(e.target.value);
    }

    const list = { ...solicitacaoMotoboy, [name]: value };

    setSolicitacaoMotoboy(list);
  };

  useEffect(() => {
    if (subcategoria) {
      window.scrollBy(0, 350);
    }
  }, [subcategoria]);

  const handleValeRefeicao = e => {
    setValeRefeicao(e.target.value);
  };

  const handleModalVRErroClose = () => setShowModalVRErro(false);

  const handleModalVRConfirmClose = () => setShowModalVRConfirm(false);

  useEffect(() => {
    const getUser = async () => {
      const login = JSON.parse(localStorage.getItem('login'));
      const userEmail = login.user.email;
      const response = await getUserByEmail(userEmail);

      if (response?.valeRefeicao) {
        setIsValeRefeicao(response?.valeRefeicao);
      }

      if (response?.vestuario) {
        setIsVestuario(response?.vestuario);
        setShowVestuarioMessageModal(false);
      }

      if (response?.cipaInscricao) {
        setCipaInscricao(response?.cipaInscricao);
      }

      if (response?.conselhoCuradorInscricao) {
        setConselhoCuradorInscricao(response?.conselhoCuradorInscricao);
      }
    };

    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setVrOption(valeRefeicao);
  }, [valeRefeicao]);

  const vrConfirm = () => {
    setShowModalVRConfirm(false);

    const vrData = { email, valeRefeicao };

    updateValeRefeicao(vrData);

    history.push('/');
  };

  const vestuarioConfirm = async () => {
    setShowModalVestuarioConfirm(false);

    const vestuarioObj = {
      camisa,
      calca,
      jaleco,
      calcado,
      observacoes: vestuarioObservacoes
    };

    const vestuarioData = { email, vestuarioObj };

    updateVestuario(vestuarioData);

    setShowVestuarioToast(true);

    setTimeout(() => {
      history.push('/');
    }, 5000);
  };

  useEffect(() => {
    const getNumeroCalcado = Array.from({ length: 21 }, (v, k) => (k + 29) + 1);

    setNumeroCalcado(getNumeroCalcado);
  }, []);

  const handleCalcado = e => {
    setCalcado(e.target.value);
  };

  const handleCamisa = e => {
    setCamisa(e.target.value);
  };

  const handleCalca = e => {
    setCalca(e.target.value);
  };

  const handleJaleco = e => {
    setJaleco(e.target.value);
  };

  const handleVestuarioObservacoes = e => {
    setVestuarioObservacoes(e.target.value);
  };

  const handleEquipamentoEngenhariaClinica = e => {
    setEquipamentoEngenhariaClinica(e.target.value);
  };

  const updateLoggedUser = async () => {
    const login = JSON.parse(localStorage.getItem('login'));
    const user = login?.user;

    if (!user?._id) {
      return;
    }

    const currentPhone = user.phone ? decrypt(user.phone) : '';
    const currentUnit = user.unit ? decrypt(user.unit) : '';

    if (currentPhone === telefone && currentUnit === unidade) {
      return;
    }

    await editarUsuario({
      _id: user._id,
      name: user.name ? decrypt(user.name) : nome,
      email: user.email ? decrypt(user.email) : email,
      phone: telefone,
      unit: unidade,
      institution: user.institution ?? '',
      admissionDate: user.admissionDate ? new Date(user.admissionDate) : '',
      registration: user.registration ? decrypt(user.registration) : '',
      roles: user.roles ? decryptArray(user.roles) : []
    });

    localStorage.setItem('login', JSON.stringify({
      ...login,
      user: {
        ...user,
        phone: encrypt(telefone),
        unit: encrypt(unidade)
      }
    }));
  };

  useEffect(() => {
    if (isVestuario && subcategoria === 'Vestuário') {
      setMostrarVestuario(false);
    } else {
      setMostrarVestuario(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subcategoria]);

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true);

    const data = {
      email,
      nome,
      telefone,
      categoria,
      subcategoria,
      unidade,
      relato
    };

    if (subcategoria === 'ERP - (MXM)') {
      if (!erpNome) {
        setErpError('O campo Nome completo é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (!erpEmail) {
        setErpError('O campo e-mail é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (erpEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(erpEmail)) {
        setErpError('O e-mail digitado não é válido.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (!erpMatricula) {
        setErpError('O campo Matrícula é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (erpMatricula.replace(/\D/g, '').length !== 5) {
        setErpError('A matrícula digitada não é válida.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      if (!erpUnidade) {
        setErpError('O campo Lotação é obrigatório.');

        setShowErpModal(true);
        setLoading(false);

        return;
      }

      const erp = {
        erpNome,
        erpEmail,
        erpMatricula,
        erpUnidade,
        erpAdministrador,
        erpCadastrosComuns,
        erpCadastrosComumFinanceiro,
        erpGestaoDeProcessos,
        erpCompras,
        erpContratoCompras,
        erpContasPagar,
        erpPagamentoEscritural,
        erpContasReceber,
        erpTesouraria,
        erpIntegracaoPadrao,
        erpContabil,
        erpEstoque,
        erpPatrimonio,
        erpOrcamento,
        erpReinf,
        erpEfd,
        erpEcd,
        erpEcf
      };

      data.erp = erp;
    }

    if (subcategoria === 'Formulário de Inscrição CIPAA') {
      if (!nome) {
        setCipaInscricaoError('O campo Nome completo é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!cipaInscricaoUnidade) {
        setCipaInscricaoError('O campo Unidade em que atua é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!cipaInscricaoCargo) {
        setCipaInscricaoError('O campo Cargo/Função é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!email) {
        setCipaInscricaoError('O campo e-mail é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setCipaInscricaoError('O e-mail digitado não é válido.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!matricula) {
        setCipaInscricaoError('O campo Matrícula é obrigatório.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (matricula.replace(/\D/g, '').length !== 5) {
        setCipaInscricaoError('A matrícula digitada não é válida.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!cipaInscricaoSobre) {
        setCipaInscricaoError('Marque o campo de confirmação de leitura do Edital.');

        setShowCipaInscricaoModal(true);
        setLoading(false);

        return;
      }

      const cipaInscricao = {
        nome,
        unidade: cipaInscricaoUnidade,
        cargo: cipaInscricaoCargo,
        email,
        matricula,
        sobre: cipaInscricaoSobre
      };

      data.cipaInscricao = cipaInscricao;
    }

    if (subcategoria === 'Formulário de Inscrição Conselho Curador') {
      if (!nome) {
        setConselhoCuradorInscricaoError('O campo Nome completo é obrigatório.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!conselhoCuradorInscricaoUnidade) {
        setConselhoCuradorInscricaoError('O campo Unidade em que atua é obrigatório.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!conselhoCuradorInscricaoCargo) {
        setConselhoCuradorInscricaoError('O campo Cargo/Função é obrigatório.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!email) {
        setConselhoCuradorInscricaoError('O campo e-mail é obrigatório.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setConselhoCuradorInscricaoError('O e-mail digitado não é válido.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!matricula) {
        setConselhoCuradorInscricaoError('O campo Matrícula é obrigatório.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (matricula.replace(/\D/g, '').length !== 5) {
        setConselhoCuradorInscricaoError('A matrícula digitada não é válida.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      if (!conselhoCuradorInscricaoSobre) {
        setConselhoCuradorInscricaoError('Marque o campo de confirmação de leitura do Edital.');

        setShowConselhoCuradorInscricaoModal(true);
        setLoading(false);

        return;
      }

      const conselhoCuradorInscricao = {
        nome,
        unidade: conselhoCuradorInscricaoUnidade,
        cargo: conselhoCuradorInscricaoCargo,
        email,
        matricula,
        sobre: conselhoCuradorInscricaoSobre
      };

      data.conselhoCuradorInscricao = conselhoCuradorInscricao;
    }

    if (subcategoria === 'Formulário de Criação') {
      if (!briefingPorque) {
        setBriefingError(<p>O campo <br /><br /> O que precisamos fazer? Por que você está fazendo esse pedido? <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingMedidas) {
        setBriefingError(<p>O campo <br /><br /> Quais peças devem ser desenvolvidas/criadas?Quais as medidas(largura X altura)? <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingOnde) {
        setBriefingError(<p>O campo <br /><br /> Onde serão veiculadas/expostas?(Redes sociais, portal, impressos, eventos etc.) <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingPrazo) {
        setBriefingError(<p>O campo <br /><br /> Qual é o prazo final para entrega do projeto? Sujeito a análise interna e viabilidade dos pedidos na fila de produção. <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (new Date(briefingPrazo) < Date.now()) {
        setBriefingError(<p>O campo <br /><br /> Qual é o prazo final para entrega do projeto? Sujeito a análise interna e viabilidade dos pedidos na fila de produção. <br /><br /> deve ser a partir de amanhã</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      if (!briefingDetalhe) {
        setBriefingError(<p>O campo <br /><br /> Tem mais algum detalhe?Deixe aqui o seu comentário para inspirar a nossa equipe. <br /><br /> é obrigatório</p>);

        setShowBriefingModal(true);
        setLoading(false);

        return;
      }

      const formData = new FormData();

      briefingArquivo1 && formData.append('files', briefingArquivo1);
      briefingArquivo2 && formData.append('files', briefingArquivo2);
      briefingArquivo3 && formData.append('files', briefingArquivo3);
      briefingArquivo4 && formData.append('files', briefingArquivo4);
      briefingArquivo5 && formData.append('files', briefingArquivo5);

      const response = await fetch(`${baseUrl}/ascom/upload`, {
        method: 'POST',
        headers: {
          // 'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      const files = await response.json();

      const briefing = {
        briefingPorque,
        briefingMedidas,
        briefingOnde,
        briefingPrazo,
        briefingDetalhe,
        briefingArquivos: files
      };

      data.relato = ' ';
      data.briefing = briefing;
    }

    if (subcategoria === 'Triênio') {
      const formData = new FormData();

      if (!trienioArquivo1) {
        setTrienioError(<p>Você não anexou nenhum arquivo</p>);

        setShowTrienioModal(true);
        setLoading(false);

        return;
      }

      trienioArquivo1 && formData.append('files', trienioArquivo1);
      trienioArquivo2 && formData.append('files', trienioArquivo2);
      trienioArquivo3 && formData.append('files', trienioArquivo3);
      trienioArquivo4 && formData.append('files', trienioArquivo4);
      trienioArquivo5 && formData.append('files', trienioArquivo5);

      const response = await fetch(`${baseUrl}/trienio/upload`, {
        method: 'POST',
        headers: {
          // 'Content-type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      const files = await response.json();

      const trienio = {
        trienioArquivos: files
      };

      data.relato = ' ';
      data.trienio = trienio;
    }

    if (subcategoria === 'Manutenção de Equipamentos') {
      if (!equipamentoEngenhariaClinica) {
        setEquipamentoEngenhariaClinicaError('Selecione um equipamento.');
        setShowEquipamentoEngenhariaClinicaModal(true);
        setLoading(false);

        return;
      }
    }

    if (subcategoria === 'Vestuário') {
      if (!userMatricula) {
        setVestuarioError('Somente usuários com matrícula podem escolher o vestuário.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (isVestuario) {
        setVestuarioError('Você já escolheu os tamanhos do vestuário.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!camisa) {
        setVestuarioError('O campo Camisa é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!calca) {
        setVestuarioError('O campo Calça é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!jaleco) {
        setVestuarioError('O campo Jaleco é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      if (!calcado) {
        setVestuarioError('O campo Calçado é obrigatório.');
        setShowVestuarioModal(true);
        setLoading(false);

        return;
      }

      setShowModalVestuarioConfirm(true);

      setLoading(false);

      return;
    }

    if (subcategoria === 'Vale refeição / alimentação') {
      if (!valeRefeicao) {
        setShowModalVRErro(true);
        setLoading(false);

        return;
      }

      if (valeRefeicao) {
        setShowModalVRConfirm(true);
      }

      setLoading(false);

      return;
    }

    if (categoria === 'Engenharia Clínica' && subcategoria === 'Manutenção de Equipamentos') {
      data.equipamentoEngenhariaClinica = equipamentoEngenhariaClinica;
    }

    if (categoria === 'Reposição de Material/Estoque' ||
      categoria === 'Férias' ||
      subcategoria === 'Formulário de Inscrição CIPAA' ||
      subcategoria === 'Formulário de Inscrição Conselho Curador' ||
      subcategoria === 'ERP - (MXM)') {
      data.relato = '...';
    }

    if (subcategoria === 'Solicitação de material de escritório') {
      for (let i = 0; i < materiaisEscritorio.length; i++) {
        if (materiaisEscritorio[i]['material'] === '') {
          setShowModal(true);
          setMaterialError('O campo Material de Escritório não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(materiaisEscritorio[i]['quantidade']) < 1) {
          setShowModal(true);
          setMaterialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }
      }

      data.materiaisEscritorio = materiaisEscritorio;
    }

    if (subcategoria === 'Solicitação de material de expediente') {
      for (let i = 0; i < materiaisExpediente.length; i++) {
        if (materiaisExpediente[i]['material'] === '') {
          setShowModal(true);
          setMaterialError('O campo Material de Expediente não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(materiaisExpediente[i]['quantidade']) < 1) {
          setShowModal(true);
          setMaterialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }
      }

      data.materiaisExpediente = materiaisExpediente;
    }

    if (subcategoria === 'Solicitação de material de limpeza') {
      for (let i = 0; i < materiaisLimpeza.length; i++) {
        if (materiaisLimpeza[i]['material'] === '') {
          setShowModal(true);
          setMaterialError('O campo Material de Limpeza não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(materiaisLimpeza[i]['quantidade']) < 1) {
          setShowModal(true);
          setMaterialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }
      }

      data.materiaisLimpeza = materiaisLimpeza;
    }

    if (subcategoria === 'Solicitação emergencial de insumos') {
      for (let i = 0; i < suprimentos.length; i++) {
        if (suprimentos[i]['tipoInsumo'] === '') {
          setShowModal(true);
          setSuprimentoError(`O campo Tipo de Insumo não pode estar vazio (linha ${i + 1}).`);
          setLoading(false);

          return;
        }

        if (suprimentos[i]['descricao'] === '') {
          setShowModal(true);
          setSuprimentoError(`O campo Descrição de Insumos não pode estar vazio (linha ${i + 1}).`);
          setLoading(false);

          return;
        }

        if (Number(suprimentos[i]['quantidade']) < 1) {
          setShowModal(true);
          setSuprimentoError(`O campo Quantidade não pode ser menor que 1 (linha ${i + 1}).`);
          setLoading(false);

          return;
        }

        suprimentos[i]['quantidadeAtendida'] = Number(suprimentos[i]['quantidade']);
      }

      data.requerimentoInsumos = suprimentos.map(item => ({
        tipoInsumo: item.tipoInsumo,
        codigoInterno: item.codigoInterno,
        descricao: item.descricao,
        apresentacao: item.apresentacao,
        qtdApresentacao: item.qtdApresentacao,
        quantidade: item.quantidade,
        quantidadeAtendida: item.quantidadeAtendida
      }));
    }

    if (subcategoria === 'Solicitação emergencial de medicamentos') {
      for (let i = 0; i < medicamentosEmergenciais.length; i++) {
        if (medicamentosEmergenciais[i]['tipoMedicamento'] === '') {
          setShowModal(true);
          setMedicamentoEmergencialError('O campo Tipo de Medicamento não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (medicamentosEmergenciais[i]['descricao'] === '') {
          setShowModal(true);
          setMedicamentoEmergencialError('O campo Descrição de Medicamentos não pode estar vazio.');
          setLoading(false);

          return;
        }

        if (Number(medicamentosEmergenciais[i]['quantidade']) < 1) {
          setShowModal(true);
          setMedicamentoEmergencialError('O campo Quantidade não pode ser menor que 1.');
          setLoading(false);

          return;
        }

        medicamentosEmergenciais[i]['quantidadeAtendida'] = Number(medicamentosEmergenciais[i]['quantidade']);
      }

      data.requerimentoMedicamentos = medicamentosEmergenciais.map(item => ({
        tipoMedicamento: item.tipoMedicamento,
        codigoInterno: item.codigoInterno,
        descricao: item.descricao,
        quantidade: item.quantidade,
        quantidadeAtendida: item.quantidadeAtendida
      }));
    }

    if (subcategoria === 'Solicitação de transporte de pessoas') {
      if (solicitacaoVeiculo.veiculoData === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Data do transporte.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoHora === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Hora do transporte.');
        setLoading(false);

        return;
      }

      const veiculoDateTimeError = getTransportDateTimeError(solicitacaoVeiculo.veiculoData, solicitacaoVeiculo.veiculoHora);

      if (veiculoDateTimeError) {
        setShowModal(true);
        setVeiculoError(veiculoDateTimeError);
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoTempo === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Tempo estimado.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoPassageiro === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Nome do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoTelefone === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Telefone do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoSaida === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço da saída.');
        setLoading(false);

        return;
      }

      if (solicitacaoVeiculo.veiculoDestino === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço do destino.');
        setLoading(false);

        return;
      }

      data.solicitacaoVeiculo = solicitacaoVeiculo;

      data.solicitacaoVeiculo.veiculoData = new Date(data.solicitacaoVeiculo.veiculoData);
    }

    if (subcategoria === 'Solicitação de transporte de materiais') {
      if (solicitacaoMotoboy.motoboyData === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Data do transporte.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyHora === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Hora do transporte.');
        setLoading(false);

        return;
      }

      const motoboyDateTimeError = getTransportDateTimeError(solicitacaoMotoboy.motoboyData, solicitacaoMotoboy.motoboyHora);

      if (motoboyDateTimeError) {
        setShowModal(true);
        setVeiculoError(motoboyDateTimeError);
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyTempo === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Tempo estimado.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyPassageiro === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Nome do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyTelefone === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Telefone do passageiro.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboySaida === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço da saída.');
        setLoading(false);

        return;
      }

      if (solicitacaoMotoboy.motoboyDestino === '') {
        setShowModal(true);
        setVeiculoError('Preencha o campo Endereço do destino.');
        setLoading(false);

        return;
      }

      data.solicitacaoMotoboy = solicitacaoMotoboy;

      data.solicitacaoMotoboy.motoboyData = new Date(data.solicitacaoMotoboy.motoboyData);
    }

    if (subcategoria === 'Criação de e-mail corporativo') {
      createEmail.registration = formatarMatricula(createEmail.registration);

      if (createEmail.registration === '') {
        setShowEmailModal(true);
        setEmailError('O campo Matrícula é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.registration.length !== 6) {
        setShowEmailModal(true);
        setEmailError('A Matrícula deve ter 5 números.');
        setLoading(false);

        return;
      }

      if (createEmail.name === '') {
        setShowEmailModal(true);
        setEmailError('O campo Nome é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.email === '') {
        setShowEmailModal(true);
        setEmailError('O campo E-mail sugerido é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.phone === '') {
        setShowEmailModal(true);
        setEmailError('O campo Telefone é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.admissionDate === '') {
        setShowEmailModal(true);
        setEmailError('O campo Data de admissão é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.unit === '') {
        setShowEmailModal(true);
        setEmailError('O campo Unidade é obrigatório.');
        setLoading(false);

        return;
      }

      if (createEmail.job === '') {
        setShowEmailModal(true);
        setEmailError('O campo Cargo é obrigatório.');
        setLoading(false);

        return;
      }

      const dataCriacaoEmail = {
        registration: createEmail.registration,
        name: createEmail.name,
        email: createEmail.email,
        phone: createEmail.phone,
        admissionDate: new Date(createEmail.admissionDate),
        unit: createEmail.unit,
        job: createEmail.job,
        sisged: createEmail.sisged
      };

      data.criacaoEmail = dataCriacaoEmail;
    }

    if (subcategoria === 'Sistemas de Saúde') {
      if (!loginSuporte?.tipo) {
        setLoginSistemasError('O campo Login ou Suporte é obrigatório.');
        setShowLoginSistemasModal(true);
        setLoading(false);

        return;
      }

      if (!loginSistemas) {
        setLoginSistemasError('O campo Sistema é obrigatório.');
        setShowLoginSistemasModal(true);
        setLoading(false);

        return;
      }

      const notValidate = (loginSistemas !== 'CNES' && loginSistemas !== 'BPA' && loginSistemas !== 'RAAS' && loginSistemas !== 'Outros');

      if (loginSuporte?.tipo === 'login') {
        if (notValidate && !loginSuporte?.unidade) {
          setLoginSistemasError('O campo Unidade é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.nome) {
          setLoginSistemasError('O campo Nome Completo é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.cpf) {
          setLoginSistemasError('O campo CPF é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && cpfValidator(loginSuporte?.cpf)?.error) {
          setLoginSistemasError(cpfValidator(loginSuporte?.cpf)?.message);
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.cns) {
          setLoginSistemasError('O campo CNS é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !cnsValidator(loginSuporte?.cns)) {
          setLoginSistemasError('O CNS digitado não é válido.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.equipe) {
          setLoginSistemasError('O campo Equipe é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.cbo) {
          setLoginSistemasError('O campo CBO é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && loginSuporte?.cbo?.length !== 6) {
          setLoginSistemasError('O campo CBO deve conter exatamente 6 números.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.email) {
          setLoginSistemasError('O campo e-mail é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !emailValidator(loginSuporte?.email)) {
          setLoginSistemasError('O e-mail digitado não é válido.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        if (notValidate && !loginSuporte?.telefone) {
          setLoginSistemasError('O campo Telefone é obrigatório.');
          setShowLoginSistemasModal(true);
          setLoading(false);

          return;
        }

        const dataLoginSistemas = {
          tipo: loginSuporte?.tipo ? loginSuporte?.tipo : '',
          sistema: loginSistemas ? loginSistemas : '',
          unidade: loginSuporte?.unidade ? loginSuporte?.unidade : '',
          nome: loginSuporte?.nome ? loginSuporte?.nome : '',
          cpf: loginSuporte?.cpf ? cpfMask(loginSuporte?.cpf) : '',
          cns: loginSuporte?.cns ? loginSuporte?.cns : '',
          equipe: loginSuporte?.equipe ? loginSuporte?.equipe : '',
          cbo: loginSuporte?.cbo ? loginSuporte?.cbo : '',
          registroProfissional: loginSuporte?.registroProfissional ? loginSuporte?.registroProfissional : '',
          email: loginSuporte?.email ? loginSuporte?.email : '',
          telefone: loginSuporte?.telefone ? phoneMask(loginSuporte?.telefone) : ''
        };

        data.loginSistemas = dataLoginSistemas;
      }

      if (loginSuporte?.tipo === 'suporte') {
        const suporteFormData = new FormData();

        suporteArquivo1 && suporteFormData.append('files', suporteArquivo1);
        suporteArquivo2 && suporteFormData.append('files', suporteArquivo2);
        suporteArquivo3 && suporteFormData.append('files', suporteArquivo3);
        suporteArquivo4 && suporteFormData.append('files', suporteArquivo4);
        suporteArquivo5 && suporteFormData.append('files', suporteArquivo5);

        const response = await fetch(`${baseUrl}/suporte/upload`, {
          method: 'POST',
          headers: {
            // 'Content-type': 'multipart/form-data',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: suporteFormData
        });

        const filesSuporte = await response.json();

        const dataLoginSistemas = {
          tipo: loginSuporte?.tipo,
          sistema: loginSistemas,
          suporteArquivos: filesSuporte
        };

        data.loginSistemas = dataLoginSistemas;
      }
    }

    if (subcategoria === 'Ponto Eletrônico') {
      if (!pontoEletronico) {
        setRelatoError('O campo Assunto é obrigatório');
        setShowRelatoModal(true);
        setLoading(false);

        return;
      }

      data.pontoEletronico = {
        assunto: pontoEletronico,
      };
    }

    const categoriasExcluidas = [
      'Manutenção de rede/internet',
      'Manutenção VOIP (Telefone Fixo)'
    ];

    if (categoria === 'Suporte de TI') {
      if (subcategoria.includes('Manutenção') && !categoriasExcluidas.includes(subcategoria)) {
        if (!patrimonioTi) {
          setTiError('O campo Patrimônio é obrigatório.');
          setShowTiModal(true);
          setLoading(false);

          return;
        }
      }

      data.suporteTi = {
        telContatoTi,
        patrimonioTi,
        empresaResp: ''
      };
    }

    if (data.relato === '' && subcategoria !== 'Criação de e-mail corporativo') {
      setShowRelatoModal(true);
      setRelatoError('Descreva a solicitação.');
      setLoading(false);

      return;
    }

    const sla = categorias
      .filter(item => item.categoria === categoria)[0].subcategoria
      .filter(item => item.nome === subcategoria)[0].sla;

    const responder = categorias
      .filter(item => item.categoria === categoria)[0].subcategoria
      .filter(item => item.nome === subcategoria)[0].responder;

    data.createdAt = new Date();
    data.sla = sla;
    data.status = 'Aberto';
    data.responder = responder;

    if (subcategoria === 'Formulário de Inscrição CIPAA') {
      getCipaInscricao(email);
    }

    if (subcategoria === 'Formulário de Inscrição Conselho Curador') {
      putConselhoCuradorInscricao(email);
    }

    try {
      await criarChamado(data);
    } catch (error) {
      setShowModal(true);
      setVeiculoError(error.message);
      setLoading(false);

      return;
    }

    await updateLoggedUser();

    setLoading(false);

    history.push({
      pathname: '/solicitacoes',
      state: { isRedirect: true }
    });
  };

  const insumosBuscaFiltrados = buscaInsumo.trim()
    ? listaInsumosBusca
      .filter(item => formatInsumoDescricao(item).toLowerCase().includes(buscaInsumo.toLowerCase()))
      .slice(0, 50)
    : [];

  const medicamentosBuscaFiltrados = buscaMedicamento.trim()
    ? listaMedicamentosBusca
      .filter(item => item.descricao?.toLowerCase().includes(buscaMedicamento.toLowerCase()))
      .slice(0, 50)
    : [];

  return (
    <Container className={styles.container}>
      <Row className={styles.title}>Nova Solicitação</Row>
      <Form onSubmit={handleSubmit} noValidate >
        {usuario && (
          <>
            <Form.Group controlId="formEmail" className="mt-4">
              <Form.Label>*e-mail:</Form.Label>
              <Form.Control
                type="email"
                required
                name="formEmail"
                onChange={e => handleEmail(e)}
                value={userEmail}
                readOnly />
            </Form.Group>

            <Row>
              <Col sm={7}>
                <Form.Group controlId="formNome" className="mt-4">
                  <Form.Label>*Nome do Solicitante:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="formNome"
                    onChange={e => handleNome(e)}
                    value={userNome}
                    readOnly
                  />
                </Form.Group>
              </Col>

              <Col sm={5}>
                <Form.Group controlId="formTelefone" className="mt-4">
                  <Form.Label>*Telefone:</Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="formTelefone"
                    onChange={e => handleTelefone(e)}
                    value={userTelefone}
                    placeholder="(21) 99999-9999"
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col>
            <Unidades
              handleUnidade={handleUnidade}
              getUnidades={unidades}
              userUnidade={userUnidade}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            {unidade && (
              <Categorias
                handleCategoria={handleCategoria}
                getCategorias={categorias}
              />
            )}
          </Col>

          <Col>
            {categoria === 'Suporte de TI' && (
              <SuporteTi
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                unidade={unidade}
              />
            )}

            {categoria === 'Manutenção Predial' && (
              <ManutencaoPredial
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Elétrica e Iluminação' && (
              <Eletrica
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Água e Esgoto' && (
              <Hidrossanitario
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Ar-Condicionado' && (
              <Mecanica
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Manutenção de Equipamentos e Mobiliários' && (
              <ManutencaoEquip
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Requisição Emergencial de Suprimentos' && (
              <Reposicao
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
              />
            )}

            {categoria === 'Agendamento de Veículo' && (
              <Veiculo
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                unidade={unidade}
              />
            )}

            {categoria === 'Demonstrativos' && (
              <Demonstrativos
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Cadastro' && (
              <Cadastro
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Eleição' && (
              <Votacao
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Engenharia Clínica' && (
              <EngenhariaClinica
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Solicitações ASCOM' && (
              <Ascom
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Sistemas Administrativos - Criação de Login/Suporte' && (
              <SuporteSistemas
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}

            {categoria === 'Solicitações de Ponto Eletrônico' && (
              <PontoEletronico
                handleSubcategoria={handleSubcategoria}
                getCategorias={categorias}
                subcategoria={subcategoria}
              />
            )}
          </Col>
        </Row>

        {subcategoria === 'Solicitação emergencial de insumos' && (
          <Row className={styles.insumo_search_row}>
            <Col>
              <Form.Group controlId="buscaDescricaoInsumo" className="mt-4">
                <Form.Label>Buscar por descrição</Form.Label>
                <div className={styles.insumo_search_container}>
                  <Form.Control
                    className={styles.insumo_search_input}
                    value={buscaInsumo}
                    onChange={e => handleBuscaInsumo(e.target.value)}
                    onFocus={() => setShowInsumoBuscaOptions(Boolean(buscaInsumo))}
                    onBlur={() => setShowInsumoBuscaOptions(false)}
                    autoComplete="off"
                  />
                  {showInsumoBuscaOptions && insumosBuscaFiltrados.length > 0 && (
                    <div className={styles.insumo_search_options}>
                      {insumosBuscaFiltrados.map(item => (
                        <button
                          key={`${item.codigoInterno}-${formatInsumoDescricao(item)}`}
                          type="button"
                          className={styles.insumo_search_option}
                          onMouseDown={() => handleSelecionarInsumoBusca(item)}
                        >
                          {formatInsumoDescricao(item)}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        )}

        {subcategoria === 'Solicitação emergencial de medicamentos' && (
          <Row className={styles.insumo_search_row}>
            <Col>
              <Form.Group controlId="buscaDescricaoMedicamento" className="mt-4">
                <Form.Label>Buscar por descrição</Form.Label>
                <div className={styles.insumo_search_container}>
                  <Form.Control
                    className={styles.insumo_search_input}
                    value={buscaMedicamento}
                    onChange={e => handleBuscaMedicamento(e.target.value)}
                    onFocus={() => setShowMedicamentoBuscaOptions(Boolean(buscaMedicamento))}
                    onBlur={() => setShowMedicamentoBuscaOptions(false)}
                    autoComplete="off"
                  />
                  {showMedicamentoBuscaOptions && medicamentosBuscaFiltrados.length > 0 && (
                    <div className={styles.insumo_search_options}>
                      {medicamentosBuscaFiltrados.map(item => (
                        <button
                          key={`${item.codigoInterno}-${item.descricao}`}
                          type="button"
                          className={styles.insumo_search_option}
                          onMouseDown={() => handleSelecionarMedicamentoBusca(item)}
                        >
                          {item.descricao}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        )}

        {subcategoria === 'Criação de e-mail corporativo' && (
          <Email
            handleCreateEmail={handleCreateEmail}
            unidades={unidades}
            showEmailModal={showEmailModal}
            closeEmailModal={closeEmailModal}
            emailError={emailError}
            createEmail={createEmail}
          />
        )}

        {subcategoria === 'Sistemas de Saúde' && (
          <LoginSistemas
            handleLoginSistemas={handleLoginSistemas}
            loginSistemas={loginSistemas}
            showLoginSistemasModal={showLoginSistemasModal}
            loginSistemasError={loginSistemasError}
            handleLoginSistemasModalClose={handleLoginSistemasModalClose}
            loginSuporte={loginSuporte}
            handleLoginSuporte={handleLoginSuporte}
            unidadesSistema={unidadesPesquisa}
            handleSuporteArquivo={handleSuporteArquivo}
            suporteArquivo1={suporteArquivo1}
            suporteArquivo2={suporteArquivo2}
            suporteArquivo3={suporteArquivo3}
            suporteArquivo4={suporteArquivo4}
            suporteArquivo5={suporteArquivo5}
            resetSuporteArquivo={resetSuporteArquivo}
            showSuporteModal={showSuporteModal}
            handleSuporteModalClose={handleSuporteModalClose}
            suporteError={suporteError}
          />
        )}

        {subcategoria === 'Solicitação de medicamentos' && (
          <>
            <MedicamentosSaudeMental
              medicamentosSaudeMental={medicamentosSaudeMental}
              listaSaudeMental={listaSaudeMental}
              handleModalShow={handleModalShow}
              showModal={showModal}
              handleModalClose={handleModalClose}
              handleRemoveMedicamentoSaudeMental={handleRemoveMedicamentoSaudeMental}
              handleAddMedicamentoSaudeMental={handleAddMedicamentoSaudeMental}
              handleMedicamentosSaudeMental={handleMedicamentosSaudeMental}
              handleSwitch={handleSwitch}
            />

            {showMedicamentosAtencaoBasica && (
              <MedicamentosAtencaoBasica
                medicamentosAtencaoBasica={medicamentosAtencaoBasica}
                listaAtencaoBasica={listaAtencaoBasica}
                handleModalShow={handleModalShow}
                showModal={showModal}
                handleModalClose={handleModalClose}
                handleRemoveMedicamentoAtrequiredencaoBasica={handleRemoveMedicamentoAtencaoBasica}
                handleAddMedicamentoAtencaoBasica={handleAddMedicamentoAtencaoBasica}
                handleMedicamentosAtencaoBasica={handleMedicamentosAtencaoBasica}
              />
            )}
          </>
        )}

        {subcategoria === 'Solicitação emergencial de insumos' && (
          <Suprimentos
            tipoInsumoSelect={tipoInsumoSelect}
            suprimentos={suprimentos}
            getListaSuprimentosByTipo={getListaSuprimentosByTipo}
            handleSuprimentos={handleSuprimentos}
            handleSuprimentoSelecionado={handleSuprimentoSelecionado}
            handleTipoInsumo={handleTipoInsumo}
            handleRemoveSuprimentos={handleRemoveSuprimentos}
            handleAddSuprimentos={handleAddSuprimentos}
            showModal={showModal}
            handleModalClose={handleModalClose}
            suprimentoError={suprimentoError}
          />
        )}

        {subcategoria === 'Solicitação emergencial de medicamentos' && (
          <MedicamentosEmergenciais
            tipoMedicamentoSelect={tipoMedicamentoSelect}
            medicamentos={medicamentosEmergenciais}
            getListaMedicamentosByTipo={getListaMedicamentosByTipo}
            handleMedicamentos={handleMedicamentosEmergenciais}
            handleTipoMedicamento={handleTipoMedicamento}
            handleRemoveMedicamentos={handleRemoveMedicamentosEmergenciais}
            handleAddMedicamentos={handleAddMedicamentosEmergenciais}
            showModal={showModal}
            handleModalClose={handleModalClose}
            medicamentoError={medicamentoEmergencialError}
          />
        )}

        {subcategoria === 'Solicitação de material de escritório' && (
          <MateriaisEscritorio
            materiaisEscritorio={materiaisEscritorio}
            listaMateriaisEscritorio={listaMateriaisEscritorio}
            handleMateriaisEscritorio={handleMateriaisEscritorio}
            handleRemoveMateriaisEscritorio={handleRemoveMateriaisEscritorio}
            handleAddMateriaisEscritorio={handleAddMateriaisEscritorio}
            showModal={showModal}
            handleModalClose={handleModalClose}
            materialError={materialError}
          />
        )}

        {subcategoria === 'Solicitação de material de expediente' && (
          <MateriaisExpediente
            materiaisExpediente={materiaisExpediente}
            listaMateriaisExpediente={listaMateriaisExpediente}
            handleMateriaisExpediente={handleMateriaisExpediente}
            handleRemoveMateriaisExpediente={handleRemoveMateriaisExpediente}
            handleAddMateriaisExpediente={handleAddMateriaisExpediente}
            showModal={showModal}
            handleModalClose={handleModalClose}
            materialError={materialError}
          />
        )}

        {subcategoria === 'Solicitação de material de limpeza' && (
          <MateriaisLimpeza
            materiaisLimpeza={materiaisLimpeza}
            listaMateriaisLimpeza={listaMateriaisLimpeza}
            handleMateriaisLimpeza={handleMateriaisLimpeza}
            handleRemoveMateriaisLimpeza={handleRemoveMateriaisLimpeza}
            handleAddMateriaisLimpeza={handleAddMateriaisLimpeza}
            showModal={showModal}
            handleModalClose={handleModalClose}
            materialError={materialError}
          />
        )}

        {subcategoria === 'Solicitação de transporte de pessoas' && (
          <SolicitacaoVeiculo
            handleSolicitacaoVeiculo={handleSolicitacaoVeiculo}
            veiculoTempo={solicitacaoVeiculo.veiculoTempo}
            showModal={showModal}
            handleModalClose={handleModalClose}
            veiculoError={veiculoError}
          />
        )}

        {subcategoria === 'Solicitação de transporte de materiais' && (
          <SolicitacaoMotoboy
            handleSolicitacaoMotoboy={handleSolicitacaoMotoboy}
            motoboyTempo={solicitacaoMotoboy.motoboyTempo}
            showModal={showModal}
            handleModalClose={handleModalClose}
            veiculoError={veiculoError}
          />
        )}

        {subcategoria === 'Vale refeição / alimentação' && (
          <ValeRefeicao
            handleValeRefeicao={handleValeRefeicao}
            showModalVRErro={showModalVRErro}
            handleModalVRErroClose={handleModalVRErroClose}
            showModalVRConfirm={showModalVRConfirm}
            handleModalVRConfirmClose={handleModalVRConfirmClose}
            vrOption={vrOption}
            vrConfirm={vrConfirm}
            isValeRefeicao={isValeRefeicao}
          />
        )}

        {subcategoria === 'Vestuário' && (
          <Vestuario
            handleCalcado={handleCalcado}
            calcado={calcado}
            numeroCalcado={numeroCalcado}
            showVestuarioModal={showVestuarioModal}
            handleVestuarioModalClose={handleVestuarioModalClose}
            vestuarioError={vestuarioError}
            handleCamisa={handleCamisa}
            camisa={camisa}
            handleCalca={handleCalca}
            calca={calca}
            handleJaleco={handleJaleco}
            jaleco={jaleco}
            handleVestuarioObservacoes={handleVestuarioObservacoes}
            vestuarioObservacoes={vestuarioObservacoes}
            showModalVestuarioConfirm={showModalVestuarioConfirm}
            handleModalVestuarioConfirmClose={handleModalVestuarioConfirmClose}
            showVestuarioMessageModal={showVestuarioMessageModal}
            handleVestuarioMessageModalClose={handleVestuarioMessageModalClose}
            isVestuario={isVestuario}
            vestuarioConfirm={vestuarioConfirm}
          />
        )}

        {subcategoria === 'Triênio' && (
          <Trienio
            trienioArquivo1={trienioArquivo1}
            trienioArquivo2={trienioArquivo2}
            trienioArquivo3={trienioArquivo3}
            trienioArquivo4={trienioArquivo4}
            trienioArquivo5={trienioArquivo5}
            handleTrienioArquivo={handleTrienioArquivo}
            resetTrienioArquivo={resetTrienioArquivo}
            showTrienioModal={showTrienioModal}
            handleTrienioModalClose={handleTrienioModalClose}
            trienioError={trienioError}
          />
        )}

        {subcategoria === 'Manutenção de Equipamentos' && (
          <ManutencaoEquipamentos
            handleEquipamentoEngenhariaClinica={handleEquipamentoEngenhariaClinica}
            equipamentoEngenhariaClinica={equipamentoEngenhariaClinica}
            equipamentosEngenhariaClinica={equipamentosEngenhariaClinica}
          />
        )}

        {!isErp && subcategoria === 'ERP - (MXM)' && (
          <Alert variant="primary" className="mt-4">
            <Alert.Heading>Atenção!</Alert.Heading>
            <p>
              O seu Perfil não tem permissão para acessar esse módulo.
            </p>
            <p>
              Solicite a sua permissão em admusu@fesaude.niteroi.rj.gov.br
            </p>
          </Alert>
        )}

        {isErp && subcategoria === 'ERP - (MXM)' && (
          <Erp
            erpNome={erpNome}
            handleErpNome={handleErpNome}
            erpEmail={erpEmail}
            handleErpEmail={handleErpEmail}
            erpMatricula={erpMatricula}
            handleErpMatricula={handleErpMatricula}
            erpUnidade={erpUnidade}
            handleErpUnidade={handleErpUnidade}
            erpAdministrador={erpAdministrador}
            handleErpAdministrador={handleErpAdministrador}
            handleErpCadastrosComuns={handleErpCadastrosComuns}
            erpCadastrosComuns={erpCadastrosComuns}
            handleErpCadastrosComumFinanceiro={handleErpCadastrosComumFinanceiro}
            erpCadastrosComumFinanceiro={erpCadastrosComumFinanceiro}
            handleErpGestaoDeProcessos={handleErpGestaoDeProcessos}
            erpGestaoDeProcessos={erpGestaoDeProcessos}
            handleErpCompras={handleErpCompras}
            erpCompras={erpCompras}
            handleErpContratoCompras={handleErpContratoCompras}
            erpContratoCompras={erpContratoCompras}
            handleErpContasPagar={handleErpContasPagar}
            erpContasPagar={erpContasPagar}
            handleErpPagamentoEscritural={handleErpPagamentoEscritural}
            erpPagamentoEscritural={erpPagamentoEscritural}
            handleErpContasReceber={handleErpContasReceber}
            erpContasReceber={erpContasReceber}
            handleErpTesouraria={handleErpTesouraria}
            erpTesouraria={erpTesouraria}
            handleErpIntegracaoPadrao={handleErpIntegracaoPadrao}
            erpIntegracaoPadrao={erpIntegracaoPadrao}
            handleErpContabil={handleErpContabil}
            erpContabil={erpContabil}
            handleErpEstoque={handleErpEstoque}
            erpEstoque={erpEstoque}
            handleErpPatrimonio={handleErpPatrimonio}
            erpPatrimonio={erpPatrimonio}
            handleErpOrcamento={handleErpOrcamento}
            erpOrcamento={erpOrcamento}
            handleErpReinf={handleErpReinf}
            erpReinf={erpReinf}
            handleErpEfd={handleErpEfd}
            erpEfd={erpEfd}
            handleErpEcd={handleErpEcd}
            erpEcd={erpEcd}
            handleErpEcf={handleErpEcf}
            erpEcf={erpEcf}
            showErpModal={showErpModal}
            handleErpModalClose={handleErpModalClose}
            erpError={erpError}
          />
        )}

        {subcategoria === 'Formulário de Criação' && (
          <Briefing
            handleBriefingPorque={handleBriefingPorque}
            handleBriefingMedidas={handleBriefingMedidas}
            handleBriefingOnde={handleBriefingOnde}
            handleBriefingPrazo={handleBriefingPrazo}
            handleBriefingDetalhe={handleBriefingDetalhe}
            resetBriefingArquivo={resetBriefingArquivo}
            briefingArquivo1={briefingArquivo1}
            briefingArquivo2={briefingArquivo2}
            briefingArquivo3={briefingArquivo3}
            briefingArquivo4={briefingArquivo4}
            briefingArquivo5={briefingArquivo5}
            showBriefingModal={showBriefingModal}
            handleBriefingModalClose={handleBriefingModalClose}
            briefingError={briefingError}
            handleBriefingArquivo={handleBriefingArquivo}
          />
        )}

        {subcategoria === 'Ponto Eletrônico' && (
          <Form.Group className='mt-3'>
            <Form.Label>Assunto:</Form.Label>
            <Form.Select
              className="border border-secondary"
              required
              name="pontoEletronico"
              value={pontoEletronico}
              onChange={handlePontoEletronico}
            >
              <option value="">Selecione o assunto</option>
              {pontoEletronicoSelect.map(item => (
                <option key={item} value={item}>{item}</option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {subcategoria === 'Formulário de Inscrição CIPAA' && prazoInscricaoCipaa && !cipaInscricao.inscrito && (
          <CipaInscricao
            handleCipaInscricaoUnidade={handleCipaInscricaoUnidade}
            cipaInscricaoUnidade={cipaInscricaoUnidade}
            handleCipaInscricaoCargo={handleCipaInscricaoCargo}
            cipaInscricaoCargo={cipaInscricaoCargo}
            handleCipaInscricaoSobre={handleCipaInscricaoSobre}
            showCipaInscricaoModal={showCipaInscricaoModal}
            handleCipaInscricaoModalClose={handleCipaInscricaoModalClose}
            cipaInscricaoError={cipaInscricaoError}
            nome={nome}
            email={email}
            matricula={matricula}
          />
        )}

        {subcategoria === 'Formulário de Inscrição CIPAA' && !prazoInscricaoCipaa && (
          <Alert variant="warning" className="mt-4">
            <Alert.Heading>Atenção</Alert.Heading>
            <p>
              O prazo da Inscrição para a Eleição da CIPAA já terminou.
            </p>
          </Alert>
        )}

        {subcategoria === 'Formulário de Inscrição CIPAA' && cipaInscricao?.inscrito && (
          <>
            <Row className={styles.cipa_ja_votou}>Você já se inscreveu em {cipaInscricao?.createdAt ? formatarDataEHora(cipaInscricao?.createdAt) : ''}</Row>

            <div className={styles.title_cipa_container}>
              <div className={styles.cipa_title}>
                Formulário de Inscrição CIPAA
              </div>
            </div>
          </>
        )}

        <Modal show={showEquipamentoEngenhariaClinicaModal} onHide={handleEquipamentoEngenhariaClinicaModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Erro</Modal.Title>
          </Modal.Header>
          <Modal.Body>{equipamentoEngenhariaClinicaError}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleEquipamentoEngenhariaClinicaModalClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>

        {subcategoria === 'Apuração CIPAA' && history.push('/cipaa/apuracao')}

        {subcategoria === 'Formulário de Inscrição Conselho Curador' && prazoInscricaoConselhoCurador && !conselhoCuradorInscricao.inscrito && (
          <ConselhoCuradorInscricao
            handleConselhoCuradorInscricaoUnidade={handleConselhoCuradorInscricaoUnidade}
            conselhoCuradorInscricaoUnidade={conselhoCuradorInscricaoUnidade}
            handleConselhoCuradorInscricaoCargo={handleConselhoCuradorInscricaoCargo}
            conselhoCuradorInscricaoCargo={conselhoCuradorInscricaoCargo}
            handleConselhoCuradorInscricaoSobre={handleConselhoCuradorInscricaoSobre}
            showConselhoCuradorInscricaoModal={showConselhoCuradorInscricaoModal}
            handleConselhoCuradorInscricaoModalClose={handleConselhoCuradorInscricaoModalClose}
            conselhoCuradorInscricaoError={conselhoCuradorInscricaoError}
            nome={nome}
            email={email}
            matricula={matricula}
          />
        )}

        {subcategoria === 'Formulário de Inscrição Conselho Curador' && !prazoInscricaoConselhoCurador && (
          <Alert variant="warning" className="mt-4">
            <Alert.Heading>Atenção</Alert.Heading>
            <p>
              O prazo da Inscrição para a Eleição do Conselho Curador já terminou.
            </p>
          </Alert>
        )}

        {subcategoria === 'Formulário de Inscrição Conselho Curador' && conselhoCuradorInscricao.inscrito && (
          <>
            <Row className={styles.cipa_ja_votou}>Você já se inscreveu em {formatarDataEHora(conselhoCuradorInscricao?.createdAt)}</Row>

            <div className={styles.title_cipa_container}>
              <div className={styles.cipa_title}>
                Formulário de Inscrição Conselho Curador
              </div>
            </div>
          </>
        )}

        <div aria-live="polite" aria-atomic="true" className={styles.toast}>
          <ToastContainer position="bottom-center">
            <Toast
              onClose={() => setShowVestuarioToast(false)}
              show={showVestuarioToast}
              delay={5000}
              autohide
              bg="primary"
            >
              <Toast.Header style={{ backgroundColor: "#80deea" }}>
                <strong className="me-auto" style={{ color: "#000" }}>Sucesso</strong>
              </Toast.Header>
              <Toast.Body className={styles.toastBody}>A sua escolha foi gravada com sucesso!</Toast.Body>
            </Toast>
          </ToastContainer>
        </div>

        {
          (categoria === 'Manutenção Predial' || categoria === 'Manutenção de Elétrica e Iluminação' || categoria === 'Manutenção de Água e Esgoto' || categoria === 'Manutenção de Ar-Condicionado') && subcategoria && (
            <Container>
              <Row>
                <p className={styles.manutencao_title}>
                  Em caso de emergência ou agravamento ligue para (21) 97029-6574
                </p>
              </Row>
              <Row style={{ position: 'relative' }}>
                <p className={styles.manutencao_subtitle}>
                  Favor detalhar a solicitação no campo abaixo, informando: ambiente(s), quantidade(s), etc.
                </p>
              </Row>
            </Container>
          )
        }

        {categoria === 'Suporte de TI' && (
          <SuporteTiForm
            handleTelContatoTi={handleTelContatoTi}
            telContatoTi={telContatoTi}
            subcategoria={subcategoria}
            handlePatrimonioTi={handlePatrimonioTi}
            patrimonioTi={patrimonioTi}
            showTiModal={showTiModal}
            handleTiModalClose={handleTiModalClose}
            tiError={tiError}
          />
        )}

        <Row>
          {subcategoria && subcategoria !== 'ERP - (MXM)' && categoria !== 'Demonstrativos' && categoria !== 'Cadastro' && categoria !== 'Eleição' && categoria !== 'Solicitações ASCOM' && (
            <Relato
              handleRelato={handleRelato}
              counter={counter}
              isRequired={isRequired}
              mensagemRelato={mensagemRelato}
              showRelatoModal={showRelatoModal}
              handleRelatoModalClose={handleRelatoModalClose}
              relatoError={relatoError}
            />
          )}
        </Row>

        {(subcategoria !== 'Vale refeição / alimentação' && subcategoria !== 'Apresentação dos Candidatos CIPAA') && mostrarVestuario && (subcategoria !== 'Formulário de Inscrição CIPAA' || !cipaInscricao?.inscrito) && !loading && (
          <div className="text-center mt-4">
            {subcategoria && (
              <Button variant="flat" className={styles.save_btn} type="submit">
                Enviar
              </Button>
            )}
          </div>
        )}

        {loading && (
          <div className="text-center mt-4">
            {subcategoria && (
              <Button variant="flat" className={styles.save_btn} type="submit" disabled>
                Enviando...
              </Button>
            )}
          </div>
        )}
      </Form>
    </Container>
  );
};

export default ChamadosNovo;
